import ApiService from '@/services/apiService'
import CacheService from '@/services/cacheService'

import landDocumentsDtModule from './dataTransferModules/landDocumentsDt'
import equipmentRegistrationsDtModule from './dataTransferModules/equipmentRegistrationsDt'
import equipmentFactplacesDtModule from './dataTransferModules/equipmentFactplacesDt'
import incidentsCommentsDtModule from './dataTransferModules/incidentsCommentsDt'
import incidentsDtModule from './dataTransferModules/incidentsDt'
import incidentsMyWorksToAdministrateIncidentsDtModule from './dataTransferModules/incidentsMyWorksToAdministrateIncidentsDt'
import regulationsStagesPlanWorksQualitiControlsDtModule from './dataTransferModules/regulationsStagesPlanWorksQualitiControlsDt'
import regulationsStagesPlanWorksServicePaymentsDtModule from './dataTransferModules/regulationsStagesPlanWorksServicePaymentsDt'
import regulationsStagesPlanWorksStaffPaymentsDtModule from './dataTransferModules/regulationsStagesPlanWorksStaffPaymentsDt'
import regulationsStagesPlanWorksStaffGroupsDtModule from './dataTransferModules/regulationsStagesPlanWorksStaffGroupsDt'
import regulationsStagesPlanWorksProductsDtModule from './dataTransferModules/regulationsStagesPlanWorksProductsDt'
import regulationsStagesPlanWorksMaterialsDtModule from './dataTransferModules/regulationsStagesPlanWorksMaterialsDt'

import tripsDtModule from './dataTransferModules/tripsDt'
import positionDevicesDtModule from './dataTransferModules/positionDevicesDt'
import worksServicePaymentRateNormsDtModule from './dataTransferModules/worksServicePaymentRateNormsDt'
import worksMaterialProductionRateNormsDtModule from './dataTransferModules/worksMaterialProductionRateNormsDt'
import staffAndMachineryCardsDtModule from './dataTransferModules/staffAndMachineryCardsDt'
import authDtModule from './dataTransferModules/authDt'
import userDtModule from './dataTransferModules/userDt'
import companyDtModule from './dataTransferModules/companyDt'
import companyFuelSettingsDtModule from './dataTransferModules/companyFuelSettingsDt'
import presetsDtModule from './dataTransferModules/presetsDt'
import cacheDtModule from './dataTransferModules/cacheDt'
import machinesDtModule from './dataTransferModules/machinesDt'
import equipmentDtModule from './dataTransferModules/equipmentDt'
import infrastructureTypesDtModule from './dataTransferModules/infrastructureTypesDt'
import partnersDtModule from './dataTransferModules/partnersDt'
import aggregateCardsDtModule from './dataTransferModules/aggregateCardsDt'
import infrastructureTagsDtModule from './dataTransferModules/infrastructureTagsDt'
import gpsSourcesDtModule from './dataTransferModules/gpsSourcesDt'
import identityCardsDtModule from './dataTransferModules/identityCardsDt'
import identityMountsDtModule from './dataTransferModules/identityMountsDt'
import machineBrigadeDtModule from './dataTransferModules/machineBrigadeDt'
import machinePhotosDtModule from './dataTransferModules/machinePhotosDt'
import machineTransfersDtModule from './dataTransferModules/machineTransfersDt'
import fuelDtModule from './dataTransferModules/fuelDt'
import fuelStationsDtModule from './dataTransferModules/fuelStationsDt'
import fuelStationEventsDtModule from './dataTransferModules/fuelStationEventsDt'
import fuelStationRawEventsDtModule from './dataTransferModules/fuelStationRawEventsDt'
import fuelStationGunsDtModule from './dataTransferModules/fuelStationGunsDt'
import worksMaterialConsumptionRateNormsDtModule from './dataTransferModules/worksMaterialConsumptionRateNormsDt'
import worksProductivityNormsDtModule from './dataTransferModules/worksProductivityNormsDt'
import worksQualityNormsDtModule from './dataTransferModules/worksQualityNormsDt'
import regulationsApplicationAreaDtModule from './dataTransferModules/regulationsApplicationAreaDt'
import cropsDtModule from './dataTransferModules/cropsDt'
import worksStaffPaymentRatesNormsDtModule from './dataTransferModules/worksStaffPaymentRatesNormsDt'
import positionsMachinesDtModule from './dataTransferModules/positionsMachinesDt'
import eventsDtModule from './dataTransferModules/eventsDt'
import infrastructurePhotosDtModule from './dataTransferModules/infrastructurePhotosDt'
import equipmentPhotosDtModule from './dataTransferModules/equipmentPhotosDt'
import regulationsMetricsDtModule from './dataTransferModules/regulationsMetricsDt'
import regulationsStagesDtModule from './dataTransferModules/regulationsStagesDt'
import regulationsTargetProductsDtModule from './dataTransferModules/regulationsTargetProductsDt'
import regulationsStagesPlanWorksDtModule from './dataTransferModules/regulationsStagesPlanWorksDt'
import mapsDtModule from './dataTransferModules/mapsDt'
import businessProcessesDtModule from './dataTransferModules/businessProcessesDt'
import regulationBaseFinanceAttributionDtModule from './dataTransferModules/regulationBaseFinanceAttributionDt'
import notificationsDtModule from './dataTransferModules/notificationsDt'
import regulationPlanWorkFinanceAttributionDtModule from './dataTransferModules/regulationPlanWorkFinanceAttributionDt'
import reportsDtModule from './dataTransferModules/reportsDt'
import reportFinanceByCategoriesDtModule from './dataTransferModules/reportFinanceByCategoriesDt'
import reportFinanceByDestinationDtModule from './dataTransferModules/reportFinanceByDestinationDt'
import reportFinanceByWorkTypesDtModule from './dataTransferModules/reportFinanceByWorkTypesDt'
import reportFinanceEfficiencyDtModule from './dataTransferModules/reportFinanceEfficiencyDt'
import reportFinanceProductsDtModule from './dataTransferModules/reportFinanceProductsDt'
import reportStagesProgressDtModule from './dataTransferModules/reportStagesProgressDt'
import reportStagesProgressWithWorksDtModule from './dataTransferModules/reportStagesProgressWithWorksDt'
import reportsDoneWorksCostsDtModule from './dataTransferModules/reportsDoneWorksCostsDt'
import reportsQualityControlsDt from './dataTransferModules/reportsQualityControlsDt'
import reportsDoneWorksDtModule from './dataTransferModules/reportsDoneWorksDt'
import reportsServicePaymentsDtModule from './dataTransferModules/reportsServicePaymentsDt'
import reportsStaffPaymentsDtModule from './dataTransferModules/reportsStaffPaymentsDt'
import reportsFinanceByMaterialsCategoriesDtModules from './dataTransferModules/reportsFinanceByMaterialsCategoriesDt'
import reportsFinanceByRolesDtModules from './dataTransferModules/reportsFinanceByRolesDt'
import reportsFinanceByWorkCategoriesDtModules from './dataTransferModules/reportsFinanceByWorkCategoriesDt'
import reportsFinanceByServicesDtModules from './dataTransferModules/reportsFinanceByServicesDt'
import reportsReportingDtModule from './dataTransferModules/reportsReportingDt'
import doneWorksBrigadesDtModule from './dataTransferModules/doneWorksBrigadeDt'
import doneWorksCalculationVolumeMetricsDtModule from './dataTransferModules/doneWorksCalculationVolumeMetricsDt'
import doneWorksDocumentsDtModule from './dataTransferModules/doneWorksDocumentsDt'
import doneWorksFinanceAttributionDtModule from './dataTransferModules/doneWorksFinanceAttributionDt'
import doneWorksLinksDtModule from './dataTransferModules/doneWorksLinksDt'
import doneWorksMeasuresDtModule from './dataTransferModules/doneWorksMeasuresDt'
import doneWorksPhotosDtModule from './dataTransferModules/doneWorksPhotosDt'
import doneWorksDtModule from './dataTransferModules/doneWorksDt'
import regulationsStagesPlanWorksRecomendedMachinesDtModule from './dataTransferModules/regulationsStagesPlanWorksRecomendedMachinesDt'
import regulationsStagesPlanWorksRecomendedEquipmentDtModule from './dataTransferModules/regulationsStagesPlanWorksRecomendedEquipmentDt'
import regulationsStagesPlanWorksRecomendedCounterpartiesDtModule from './dataTransferModules/regulationsStagesPlanWorksRecomendedCounterpartiesDt'
import regulationsStagesPlanWorksRecomendedStaffDtModule from './dataTransferModules/regulationsStagesPlanWorksRecomendedStaffDt'
import regulationsFinanceProductivityDtModule from './dataTransferModules/regulationsFinanceProductivityDt'
import regulationStageFinanceAttributionDtModule from './dataTransferModules/regulationStageFinanceAttributionDt'
import doneWorksManufacturedMaterialsDtModule from './dataTransferModules/doneWorksManufacturedMaterialsDt'
import doneWorksOperationalMaterialsDtModule from './dataTransferModules/doneWorksOperationalMaterialsDt'
import doneWorksServicesDtModule from './dataTransferModules/doneWorksServicesDt'
import doneWorksCalculationMaterialsMetricsDtModule from './dataTransferModules/doneWorksCalculationMaterialsMetricsDt'
import doneWorksInProgressFieldWorksDtModule from './dataTransferModules/doneWorksInProgressFieldWorksDt'
import businessProcessesActivePlanWorksDtModule from './dataTransferModules/businessProcessesActivePlanWorksDt'
import rulesBreakingDtModule from './dataTransferModules/rulesBreakingDt'
import doneWorksControlMetricDtModule from './dataTransferModules/doneWorksControlMetricDt'
import workOrdersDtModule from './dataTransferModules/workOrdersDt'
import workOrdersMaterialsDtModule from './dataTransferModules/workOrdersMaterialsDt'
import workOrdersProductsDtModule from './dataTransferModules/workOrdersProductsDt'
import doneWorksDoneFieldWorksDtModule from './dataTransferModules/doneWorksDoneFieldWorksDt'
import weighingCombinerTicketsDtModule from './dataTransferModules/weighingCombinerTicketsDt'
import doneWorksMyWorksToAdministrateDtModule from './dataTransferModules/doneWorksMyWorksToAdministrateDt'
import doneWorksMyWorksToControlDtModule from './dataTransferModules/doneWorksMyWorksToControlDt'
import doneWorksMyWorksToDoDtModule from './dataTransferModules/doneWorksMyWorksToDoDt'
import orderGeneratorsFieldsWorksDtModule from './dataTransferModules/orderGeneratorsFieldsWorksDt'
import orderGeneratorsFieldsWorksPlanWorksDtModule from './dataTransferModules/orderGeneratorsFieldsWorksPlanWorksDt'
import orderGeneratorsFieldsWorksStaffPaymentsDtModule from './dataTransferModules/orderGeneratorsFieldsWorksStaffPaymentsDt'
import orderGeneratorsFieldsWorksProductsDtModule from './dataTransferModules/orderGeneratorsFieldsWorksProductsDt'
import orderGeneratorsFieldsWorksMaterialsDtModule from './dataTransferModules/orderGeneratorsFieldsWorksMaterialsDt'
import orderGeneratorsFieldsWorksExecutorsDtModule from './dataTransferModules/orderGeneratorsFieldsWorksExecutorsDt'
import orderGeneratorsFieldsWorksQualityControlsDtModule from './dataTransferModules/orderGeneratorsFieldsWorksQualityControlsDt'
import orderGeneratorsFieldsWorksExecutorsBrigadesDtModule from './dataTransferModules/orderGeneratorsFieldsWorksExecutorsBrigadesDt'
import orderGeneratorsFieldsWorksServicesDtModule from './dataTransferModules/orderGeneratorsFieldsWorksServicesDt'
import logisticRoutesDtModule from './dataTransferModules/logisticRoutesDt'
import logisticRoutesGeoZonesDtModule from './dataTransferModules/logisticRoutesGeoZonesDt'
import reportDeviceMountsDtModule from './dataTransferModules/reportDeviceMountsDt'
import doneWorksAllFieldWorksDtModule from './dataTransferModules/doneWorksAllFieldWorksDt'
import doneWorksAllLogisticWorksDtModule from './dataTransferModules/doneWorksAllLogisticWorksDt'
import doneWorksAllHandMadeWorksDtModule from './dataTransferModules/doneWorksAllHandMadeWorksDt'
import regulationsAllPlanWorksDtModule from './dataTransferModules/regulationsAllPlanWorksDt'
import cargosDtModule from './dataTransferModules/cargosDt'
import cargoItemsDtModule from './dataTransferModules/cargoItemsDt'
import cargoTagsDtModule from './dataTransferModules/cargoTagsDt'
import apiUsagesDtModule from './dataTransferModules/apiUsagesDt'
import landsDtModule from './dataTransferModules/landsDt'
import equipmentDocumentsDtModule from './dataTransferModules/equipmentDocumentsDt'
import equipmentPledgesDtModule from './dataTransferModules/equipmentPledgesDt'
import landsCadastralCasesDtModule from './dataTransferModules/landsCadastralCasesDt'
import customGeoZonesCategoriesDtModule from './dataTransferModules/customGeoZonesCategoriesDt'
import customGeoZonesDtModule from './dataTransferModules/customGeoZonesDt'
import regulationsStaffRolesInfoDtModule from './dataTransferModules/regulationsStaffRolesInfoDt'
import businessProcessBaseExecutorsDtModule from './dataTransferModules/businessProcessBaseExecutorsDt'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'
import {
	getUniqKeyForCacheFromPayload,
	createModuleCacheKey,
	transformVersions,
	getCacheVersion,
	defaultGetEntityIdFromUrlParams,
	defaultGetSingleCachedEntity,
	delayPromiseResult,
} from '@/helpers/dataTransferCacheHelper'

const apiService = ApiService()
const cacheService = CacheService()

const { getCacheHashes } = cacheDtModule
function generatePayloadForCacheHashesRequest(sideRequestPayload) {
	const companyId = sideRequestPayload?.urlParams?.companyId

	if (!companyId) {
		return null
	}

	return {
		urlParams: {
			companyId,
		}
	}
}
async function requestCacheHashes(payload) {
	// eslint-disable-next-line no-async-promise-executor
	return new Promise(async (resolve) => {
		const transformedPayload = generatePayloadForCacheHashesRequest(payload)

		if (transformedPayload) {
			const hashes = getCacheHashes(transformedPayload)

			return resolve(hashes)
		}

		return resolve(null)
	})
}

/**
 * getting data from the cache service
 * @param {string} cacheStorage
 * @param {string} currentHashFromBack
 * @param {string} getterFunction
 * @returns {Promise}
 */
function _getDataFromCache(key, currentHashFromBack, cacheStorage) {
	return new Promise((resolve, reject) => {
		cacheService
			.cacheGetRequestWrap(key, currentHashFromBack, cacheStorage)
			.then((res) => {
				resolve(res)
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function _setDataToCache(key, data, version, dataDistributionSchema = null) {
	return new Promise((resolve, reject) => {
		cacheService
			.cacheSetRequestWrap(key, data, version, dataDistributionSchema)
			.then((res) => {
				resolve(res)
			})
			.catch((err) => {
				reject(err)
			})
	})
}

function _transferCachedData(entityConfig, payload, currentCashPayload, apiModule) {
	const keyOfHashedData = currentCashPayload[0]
	const hashOfEntity = currentCashPayload?.[1]

	return new Promise((resolve, reject) => {
		_getDataFromCache(keyOfHashedData, hashOfEntity, entityConfig.cacheStorage)
			.then((cacheResponse) => {
				resolve(cacheResponse)
			})
			.catch(() => {
				// const [, requestPromise] = apiService[entityConfig.apiServiceMethodName](payload)
				const [, requestPromise] = apiModule && apiModule[entityConfig.apiServiceMethodName] && typeof apiModule[entityConfig.apiServiceMethodName] === 'function'
					? apiModule[entityConfig.apiServiceMethodName](payload)
					: apiService[entityConfig.apiServiceMethodName](payload)

				requestPromise.then((apiRes) => {

					if (entityConfig.isSingleCachedEntity) {
						return resolve(apiRes)
					}

					_setDataToCache(keyOfHashedData, apiRes, hashOfEntity, entityConfig.dataDistributionSchema)
						.then(() => {
							_getDataFromCache(keyOfHashedData, hashOfEntity, entityConfig.cacheStorage)
								.then((newListFromCache) => {
									resolve(newListFromCache)
								})
								.catch(() => {
									resolve(apiRes)
								})
						})
						.catch(() => {
							resolve(apiRes)
						})
				})
					.catch((apiErr) => {
						reject(apiErr)
					})
			})
	})
}

export function dataTransferWrap(moduleName, entityConfig, payload, apiModule) {
	const saveVersions = (versionsFromServer, uniqKey) => {
		const transformedVersions = transformVersions(versionsFromServer)
		cacheService.updateCurrentVersions(uniqKey, transformedVersions)
	}
	const requestFromServer = () => {
		return apiModule && apiModule[entityConfig.apiServiceMethodName] && typeof apiModule[entityConfig.apiServiceMethodName] === 'function'
			? apiModule[entityConfig.apiServiceMethodName](payload)
			: apiService[entityConfig.apiServiceMethodName](payload)
	}
	const uniqKey = getUniqKeyForCacheFromPayload(payload)

	// eslint-disable-next-line no-async-promise-executor
	return new Promise(async (resolve, reject) => {
		if (moduleName === ModulesMap.CACHE && uniqKey) {
			// const currentVersions = await requestFromServer() // in this context this method requests versions
			const [, currentVersionsPromise] = requestFromServer()// in this context this method requests versions
			const currentVersions = await currentVersionsPromise

			saveVersions(currentVersions, uniqKey)

			return resolve(currentVersions)
		}

		if (!entityConfig.useCache || !uniqKey) {
			const [requestConfig, requestPromise] = requestFromServer()

			/* при логине или регистрации отправляется POST запрос но никаких версий быть не может */
			if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(requestConfig?.requestOptions?.method) && (!requestConfig?.url.includes('/auth/') && !requestConfig?.url.includes('/registration/'))) {
				const getWrappedPromise = await delayPromiseResult(requestPromise)
				const currentVersions = await requestCacheHashes(payload)

				saveVersions(currentVersions, uniqKey)

				return getWrappedPromise()
					.then((res) => resolve(res))
					.catch((err) => reject(err))
			}

			return requestPromise
				.then((res) => resolve(res))
				.catch((err) => reject(err))
		}

		const cacheKey = createModuleCacheKey(moduleName, uniqKey)
		const version = await getCacheVersion(uniqKey, cacheKey, cacheService)

		if (entityConfig.isSingleCachedEntity) {
			const dataFromCache = await _transferCachedData(entityConfig, payload, [cacheKey, version], apiModule)

			if (!dataFromCache) {
				return requestFromServer().at(1)
					.then((res) => resolve(res))
					.catch((err) => reject(err))
			}

			const singleEntity = (entityConfig.findSingleEntity || defaultGetSingleCachedEntity)(
				dataFromCache,
				(entityConfig.getEntityIdFromPayload || defaultGetEntityIdFromUrlParams)(payload)
			)

			if (singleEntity) {
				return resolve(singleEntity)
			} else {
				return requestFromServer().at(1)
					.then((res) => resolve(res))
					.catch((err) => reject(err))
			}
		} else if (entityConfig.useCache) {
			const dataFromCache = await _transferCachedData(entityConfig, payload, [cacheKey, version], apiModule)

			if (dataFromCache) {
				return resolve(dataFromCache)
			} else {
				return requestFromServer().at(1)
					.then((res) => resolve(res))
					.catch((err) => reject(err))
			}
		}

		return _transferCachedData(entityConfig, payload, [cacheKey, version], apiModule)
			.then((res) => resolve(res))
			.catch((err) => reject(err))
	})
}

/*
	создал отдельный метод который будет использоваться в абстракции DataTransferModule.
	проблема в том, что в метод dataTransferWrap в старых дт-модулях передавались такие артефакты как cashedPayload
	а мне нужно в этот метод передать 4 параметром апи-модуль что бы не было необходимости его регистрировать src/services/apiService.js
*/
export function dataTransferWrapWithIncludedApiModule(moduleName, apiModule, entityConfig, payload) {
	// debugger
	return dataTransferWrap(moduleName, entityConfig, payload, apiModule)
}

function getUserData() {
	return dataTransferWrap(dtConfig[ModulesMap.USER].currentUser)
}

export default function () {
	return {
		landDocuments: landDocumentsDtModule,
		equipmentRegistrations: equipmentRegistrationsDtModule,
		equipmentFactplaces: equipmentFactplacesDtModule,
		incidentComments: incidentsCommentsDtModule,
		incidents: incidentsDtModule,
		incidentsMyWorksToAdministrateIncidents: incidentsMyWorksToAdministrateIncidentsDtModule,
		regulationsStagesPlanWorksQualitiControls: regulationsStagesPlanWorksQualitiControlsDtModule,
		regulationsStagesPlanWorksServicePayments: regulationsStagesPlanWorksServicePaymentsDtModule,
		regulationsStagesPlanWorksStaffPayments: regulationsStagesPlanWorksStaffPaymentsDtModule,
		regulationsStagesPlanWorksStaffGroups: regulationsStagesPlanWorksStaffGroupsDtModule,
		regulationsStagesPlanWorksProducts: regulationsStagesPlanWorksProductsDtModule,
		regulationsStagesPlanWorksMaterials: regulationsStagesPlanWorksMaterialsDtModule,
		trips: tripsDtModule,
		positionDevices: positionDevicesDtModule,
		worksServicePaymentRateNorms: worksServicePaymentRateNormsDtModule,
		worksMaterialProductionRateNorms: worksMaterialProductionRateNormsDtModule,
		staffAndMachineryCards: staffAndMachineryCardsDtModule,
		cache: cacheDtModule,
		presets: presetsDtModule,
		auth: authDtModule,
		user: userDtModule,
		company: companyDtModule,
		companyFuelSettings: companyFuelSettingsDtModule,
		machines: machinesDtModule,
		equipment: equipmentDtModule,
		infrastructureTypes: infrastructureTypesDtModule,
		partners: partnersDtModule,
		aggregateCards: aggregateCardsDtModule,
		infrastructureTags: infrastructureTagsDtModule,
		gpsSources: gpsSourcesDtModule,
		identityCards: identityCardsDtModule,
		identityMounts: identityMountsDtModule,
		brigade: machineBrigadeDtModule,
		photos: machinePhotosDtModule,
		transfers: machineTransfersDtModule,
		fuel: fuelDtModule,
		worksMaterialConsumptionRateNorms: worksMaterialConsumptionRateNormsDtModule,
		worksProductivityNorms: worksProductivityNormsDtModule,
		worksQualityNorms: worksQualityNormsDtModule,
		regulationsApplicationArea: regulationsApplicationAreaDtModule,
		crops: cropsDtModule,
		worksStaffPaymentRatesNorms: worksStaffPaymentRatesNormsDtModule,
		positionsMachines: positionsMachinesDtModule,
		events: eventsDtModule,
		infrastructurePhotos: infrastructurePhotosDtModule,
		equipmentPhotos: equipmentPhotosDtModule,
		regulationsMetrics: regulationsMetricsDtModule,
		regulationsStages: regulationsStagesDtModule,
		regulationsTargetProducts: regulationsTargetProductsDtModule,
		regulationsStagesPlanWorks: regulationsStagesPlanWorksDtModule,
		maps: mapsDtModule,
		getUserData,
		businessProcesses: businessProcessesDtModule,
		regulationBaseFinanceAttribution: regulationBaseFinanceAttributionDtModule,
		notifications: notificationsDtModule,
		regulationPlanWorkFinanceAttribution: regulationPlanWorkFinanceAttributionDtModule,
		reports: reportsDtModule,
		reportsDoneWorksCosts: reportsDoneWorksCostsDtModule,
		reportsQualityControls: reportsQualityControlsDt,
		reportsDoneWorks: reportsDoneWorksDtModule,
		reportsServicePayments: reportsServicePaymentsDtModule,
		reportsStaffPayments: reportsStaffPaymentsDtModule,
		reportFinanceByCategories: reportFinanceByCategoriesDtModule,
		reportFinanceByDestination: reportFinanceByDestinationDtModule,
		reportFinanceByWorkTypes: reportFinanceByWorkTypesDtModule,
		reportFinanceEfficiency: reportFinanceEfficiencyDtModule,
		reportFinanceProducts: reportFinanceProductsDtModule,
		reportStagesProgress: reportStagesProgressDtModule,
		reportStagesProgressWithWorks: reportStagesProgressWithWorksDtModule,
		reportsFinanceByMaterialsCategories: reportsFinanceByMaterialsCategoriesDtModules,
		reportsFinanceByRoles: reportsFinanceByRolesDtModules,
		reportsFinanceByWorkCategories: reportsFinanceByWorkCategoriesDtModules,
		reportsFinanceByServices: reportsFinanceByServicesDtModules,
		doneWorksBrigade: doneWorksBrigadesDtModule,
		doneWorksCalculationVolumeMetrics: doneWorksCalculationVolumeMetricsDtModule,
		doneWorksDocuments: doneWorksDocumentsDtModule,
		doneWorksFinanceAttribution: doneWorksFinanceAttributionDtModule,
		doneWorksLinks: doneWorksLinksDtModule,
		doneWorksMeasures: doneWorksMeasuresDtModule,
		doneWorksPhotos: doneWorksPhotosDtModule,
		doneWorks: doneWorksDtModule,
		regulationsStagesPlanWorksRecomendedMachines: regulationsStagesPlanWorksRecomendedMachinesDtModule,
		regulationsStagesPlanWorksRecomendedEquipment: regulationsStagesPlanWorksRecomendedEquipmentDtModule,
		regulationsStagesPlanWorksRecomendedCounterparties: regulationsStagesPlanWorksRecomendedCounterpartiesDtModule,
		regulationsStagesPlanWorksRecomendedStaff: regulationsStagesPlanWorksRecomendedStaffDtModule,
		regulationsFinanceProductivity: regulationsFinanceProductivityDtModule,
		reportsReporting: reportsReportingDtModule,
		regulationStageFinanceAttribution: regulationStageFinanceAttributionDtModule,
		doneWorksManufacturedMaterials: doneWorksManufacturedMaterialsDtModule,
		doneWorksOperationalMaterials: doneWorksOperationalMaterialsDtModule,
		doneWorksServices: doneWorksServicesDtModule,
		doneWorksInProgressFieldWorks: doneWorksInProgressFieldWorksDtModule,
		doneWorksCalculationMaterialsMetrics: doneWorksCalculationMaterialsMetricsDtModule,
		businessProcessesActivePlanWorks: businessProcessesActivePlanWorksDtModule,
		rulesBreaking: rulesBreakingDtModule,
		fuelStations: fuelStationsDtModule,
		fuelStationEvents: fuelStationEventsDtModule,
		fuelStationRawEvents: fuelStationRawEventsDtModule,
		fuelStationGuns: fuelStationGunsDtModule,
		doneWorksControlMetrics: doneWorksControlMetricDtModule,
		workOrders: workOrdersDtModule,
		workOrdersMaterials: workOrdersMaterialsDtModule,
		workOrdersProducts: workOrdersProductsDtModule,
		doneWorksDoneFieldWorks: doneWorksDoneFieldWorksDtModule,
		weighingCombinerTickets: weighingCombinerTicketsDtModule,
		doneWorksMyWorksToAdministrate: doneWorksMyWorksToAdministrateDtModule,
		doneWorksMyWorksToControl: doneWorksMyWorksToControlDtModule,
		doneWorksMyWorksToDo: doneWorksMyWorksToDoDtModule,
		orderGeneratorsFieldsWorks: orderGeneratorsFieldsWorksDtModule,
		orderGeneratorsFieldsWorksPlanWorks: orderGeneratorsFieldsWorksPlanWorksDtModule,
		orderGeneratorsFieldsWorksStaffPayments: orderGeneratorsFieldsWorksStaffPaymentsDtModule,
		orderGeneratorsFieldsWorksProducts: orderGeneratorsFieldsWorksProductsDtModule,
		orderGeneratorsFieldsWorksMaterials: orderGeneratorsFieldsWorksMaterialsDtModule,
		orderGeneratorsFieldsWorksExecutors: orderGeneratorsFieldsWorksExecutorsDtModule,
		orderGeneratorsFieldsWorksQualityControls: orderGeneratorsFieldsWorksQualityControlsDtModule,
		orderGeneratorsFieldsWorksExecutorsBrigades: orderGeneratorsFieldsWorksExecutorsBrigadesDtModule,
		orderGeneratorsFieldsWorksServices: orderGeneratorsFieldsWorksServicesDtModule,
		logisticRoutes: logisticRoutesDtModule,
		logisticRoutesGeoZones: logisticRoutesGeoZonesDtModule,
		reportDeviceMounts: reportDeviceMountsDtModule,
		doneWorksAllFieldWorks: doneWorksAllFieldWorksDtModule,
		doneWorksAllLogisticWorks: doneWorksAllLogisticWorksDtModule,
		doneWorksAllHandMadeWorks: doneWorksAllHandMadeWorksDtModule,
		regulationsAllPlanWorks: regulationsAllPlanWorksDtModule,
		cargos: cargosDtModule,
		cargoItems: cargoItemsDtModule,
		cargoTags: cargoTagsDtModule,
		apiUsages: apiUsagesDtModule,
		lands: landsDtModule,
		equipmentDocuments: equipmentDocumentsDtModule,
		equipmentPledges: equipmentPledgesDtModule,
		landsCadastralCases: landsCadastralCasesDtModule,
		customGeoZonesCategories: customGeoZonesCategoriesDtModule,
		customGeoZones: customGeoZonesDtModule,
		regulationsStaffRolesInfo: regulationsStaffRolesInfoDtModule,
		businessProcessBaseExecutors: businessProcessBaseExecutorsDtModule,
	}
}
